import { render, staticRenderFns } from "./ProductoEmpresaRegistrarHome.vue?vue&type=template&id=2bf7490d&scoped=true&"
import script from "./ProductoEmpresaRegistrarHome.vue?vue&type=script&lang=js&"
export * from "./ProductoEmpresaRegistrarHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7490d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
